export default __webpack_public_path__ + "static/KeywordResearch_01_02@2x-33f12f5788554bcc0197a3503c178aa9.png";